import { createReducer, combineReducers } from "@reduxjs/toolkit";
import { setDeeplinkData, clearDeeplinkData, setDeeplinkLoading } from "./deeplink-actions";

const data = createReducer(null, {
  [setDeeplinkData]: (_, { payload }) => payload,
  [clearDeeplinkData]: () => null,
});

const loading = createReducer(false, {
  [setDeeplinkLoading]: (_, { payload }) => payload,
});

export default combineReducers({
  data,
  loading,
});
